import { render, staticRenderFns } from "./observation-skills.vue?vue&type=template&id=1e6b2f83&"
import script from "./observation-skills.vue?vue&type=script&lang=js&"
export * from "./observation-skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports